import { getRuntimeConfig } from '../config/runtime-config';

/**
 * Console-local equivalent of `@shared/auth/auth-config.ts`, reading
 * this app's own `AdminRuntimeConfig`. Shape matches
 * `@shared/auth/auth-config.ts::AuthConfig` exactly so
 * `AdminAuthProvider` constructs `oidc-client-ts`'s `UserManager` the
 * same way `ZitadelProvider` does.
 */
export interface AuthConfig {
  authority: string;
  clientId: string;
  scope: string;
  redirectUri: string;
  postLogoutRedirectUri: string;
  audience?: string;
}

export function loadAuthConfig(): AuthConfig {
  const cfg = getRuntimeConfig();
  if (cfg.authMode === 'mock') {
    return {
      authority: 'http://localhost:0/mock-oidc',
      clientId: 'mock-admin-console',
      scope: 'openid profile email urn:zitadel:iam:org:project:roles',
      redirectUri: `${window.location.origin}/callback`,
      postLogoutRedirectUri: `${window.location.origin}/login`,
    };
  }
  return {
    authority: cfg.zitadel.issuer,
    clientId: cfg.zitadel.clientId,
    scope: cfg.zitadel.scopes.join(' '),
    redirectUri: cfg.zitadel.redirectUri,
    postLogoutRedirectUri: cfg.zitadel.postLogoutRedirectUri,
    audience: cfg.zitadel.audience,
  };
}
